import { render, staticRenderFns } from "./AddProductLabel.vue?vue&type=template&id=12ffd22e&scoped=true&"
import script from "./AddProductLabel.vue?vue&type=script&lang=js&"
export * from "./AddProductLabel.vue?vue&type=script&lang=js&"
import style0 from "./AddProductLabel.vue?vue&type=style&index=0&id=12ffd22e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ffd22e",
  null
  
)

export default component.exports